/**
 * Session-lifetime cache of managed-product device counts (STRY0038414).
 *
 * A module-level Map, deliberately: the story requires that revisiting a tab
 * in the same session does not re-request counts already fetched, but that a
 * full page reload does. `sessionStorage` survives a reload and would fail the
 * second half; module state dies with the page and satisfies both.
 *
 * Nothing is cached server-side -- a stale count is worse than a slow one --
 * so this is the only cache in the path.
 *
 * A cached `null` means "the backend said it cannot count this one"; it is a
 * definitive answer and must not be re-requested. A network error is NOT
 * cached, so a transient failure retries on the next visit.
 */
const counts = new Map();

export function hasCachedCount(managedProductId) {
  return counts.has(managedProductId);
}

export function getCachedCount(managedProductId) {
  return counts.get(managedProductId);
}

export function setCachedCount(managedProductId, count) {
  counts.set(managedProductId, count);
}

export function missingIds(ids) {
  return (ids || []).filter(id => !counts.has(id));
}

/** Tests only — there is no product reason to clear the cache. */
export function resetCountCache() {
  counts.clear();
}
